import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import {
  ContentDialog,
  ContentDialogInit,
} from "../MDDForm/components/ContentDialog.jsx";
import { CustomerSelector } from "../../pages/users/components/CustomerSelector.jsx";
import { useCustomerSearch } from "../../hooks/useCustomerSearch.js";
import { backendPut } from "@accredo/fe-shared/services/dataService.js";

function BankAccountKundeModal({ open, onClose, bankAccount, onSuccess }) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const { customers, loading, searchCustomers, clearSearch } =
    useCustomerSearch();

  const { openCD, setOpenCD, tca, setTca } = ContentDialogInit();

  useEffect(() => {
    if (!open) {
      setOpenCD(false);
      return;
    }

    const kunde = bankAccount?.kunde;
    setSelectedCustomer(
      kunde
        ? {
            id: kunde.id,
            label: kunde.display_name,
            display: kunde.display_name,
          }
        : null
    );
    clearSearch();

    setOpenCD(true);
    // eslint-disable-next-line
  }, [open, bankAccount?.id]);

  const handleSave = async () => {
    await backendPut(`data/bank-accounts/${bankAccount.id}`, {
      label: "Kunde-Zuordnung ändern",
      setIsLoading,
      enqueueSnackbar,
      toSend: { kunde_id: selectedCustomer?.id ?? null },
      onSuccess: () => {
        enqueueSnackbar("Kunde-Zuordnung aktualisiert", {
          variant: "success",
        });
        onSuccess?.();
        onClose();
      },
    });
  };

  useEffect(() => {
    setTca({
      title: "Kunde ändern",
      maxWidth: "sm",
      content: (
        <CustomerSelector
          customers={customers}
          selected_customer={selectedCustomer}
          on_customer_change={(event, value) => setSelectedCustomer(value)}
          on_customer_input_change={(event, value) => searchCustomers(value)}
          search_loading={loading}
          message="Wählen Sie den Kunden aus, dem dieses Bankkonto zugeordnet werden soll, oder leeren Sie das Feld, um die Verknüpfung zu entfernen."
        />
      ),
      actions: (
        <>
          <Button onClick={onClose}>Abbrechen</Button>
          <Button variant="contained" onClick={handleSave}>
            Speichern
          </Button>
        </>
      ),
    });
    // eslint-disable-next-line
  }, [customers, selectedCustomer, loading]);

  return (
    <>
      <Backdrop
        open={isLoading}
        style={{ zIndex: 1300, flexDirection: "column" }}
      >
        <CircularProgress style={{ marginBottom: 16 }} />
      </Backdrop>
      <ContentDialog
        openCD={openCD}
        setOpenCD={setOpenCD}
        tca={tca}
        onClose={onClose}
      />
    </>
  );
}

BankAccountKundeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  bankAccount: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    kunde: PropTypes.shape({
      id: PropTypes.number,
      display_name: PropTypes.string,
    }),
  }),
};

export default BankAccountKundeModal;
